import { useGetCustomerProfile } from "@/api/generated/profile";
import PageConstants from "@/util/PageConstants";
import { usePathname } from "next/navigation";
import useNavigation from "./useNavigation";
import { useEffect } from "react";

export function useCheckProfile() {
  const nav = useNavigation();
  const pathname = usePathname();
  const { data, error, ...res } = useGetCustomerProfile({
    query: {
      queryKey: [PageConstants.PROFILE],
    },
  });

  // TEMP: Temporarily disabled first name and last name check in favor of always routing to register page for terms popup
  // useEffect(() => {
  //   if (!data) return;

  //   if (pathname.includes(PageConstants.REGISTER)) return;
  //   else if (!data.firstName || !data.lastName)
  //     nav.push(PageConstants.REGISTER);
  // }, [data]);

  // useEffect(() => {
  //   if (!error) return;

  //   if (pathname.includes(PageConstants.REGISTER)) return;
  //   nav.push(PageConstants.REGISTER);
  // }, [error]);

  return {
    loading: res.isPending || res.isFetching || nav.navigating,
  };
}
